export const LIMITS_STYLES = {
  APP_LAYOUT:
    'bg-bw02 h-screen pl-[8rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col fadeIn',
  LIMITS_WRAPPER: 'bg-bw00 rounded-lg w-full flex flex-col h-full',
  LIMITS_HEADER: 'py-[16px]  flex align-center justify-between',
  LIMITS_TITLE: 'font-metricR text-bw08 text-[20px]',
  LIMITS_TEXT: 'font-metricR text-bw07 text-[14px] flex flex-row-reverse',
  LIMITS_LINKS:
    'flex items-center justify-center cursor-pointer py-[16px] absolute bottom-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
  IFRAME: 'absolute w-full h-full top-0 left-0',
};

export const LIMITS_TEXTS = {
  TERMS_CONDITIONS: 'Terms & Conditions',
};
